import { z } from 'zod';
export const BrandSelectionModeSchema = z.enum(['disabled', 'organization_default', 'brand']);
export const ProjectBrandBindingParamsSchema = z
    .object({
    projectId: z.string().guid(),
})
    .strict();
export const ProjectBrandBindingSchema = z
    .object({
    projectId: z.string().guid(),
    organizationId: z.string().guid(),
    selectionMode: BrandSelectionModeSchema,
    brandId: z.string().guid().nullable(),
    updatedAt: z.string().datetime().nullable(),
})
    .strict();
export const SetProjectBrandBindingRequestSchema = z
    .object({
    organizationId: z.string().guid(),
    selectionMode: BrandSelectionModeSchema,
    brandId: z.string().guid().nullable().optional(),
})
    .strict();
/**
 * The brand a new project is created with: a concrete choice the caller
 * resolved from the organisation's default, never "follow the default", so a
 * later change of the default restyles no existing project.
 */
export const CreateProjectBrandBindingSchema = z.discriminatedUnion('selectionMode', [
    z.object({ selectionMode: z.literal('brand'), brandId: z.string().guid() }).strict(),
    z.object({ selectionMode: z.literal('disabled') }).strict(),
]);
export const BrandBindingUsageSchema = z
    .object({
    brandId: z.string().guid(),
    projectIds: z.array(z.string().guid()),
    usageCount: z.number().multipleOf(1).nonnegative(),
})
    .strict();
//# sourceMappingURL=ProjectBrandBinding.js.map